import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { scrollToCompra } from '../utils/scroll';
import { Gift } from 'lucide-react';
const bonos = [{
  title: 'BONO 1 — Consentimiento Informado Legal',
  desc: 'Cuatro modelos listos para usar. Para consultorio, domicilio, menores de edad y técnicas específicas como manipulación o punción seca. Nunca más atendés sin la documentación que protege tu matrícula.',
  img: 'https://cdn.magicpatterns.com/uploads/haw1tf99biA7sCrDt8CUi7/bono_kine_1-removebg-preview.png'
}, {
  title: 'BONO 2 — Calculadora de Honorarios Real',
  desc: 'La fórmula exacta para calcular cuánto cobrar según tus gastos reales y tu salario deseado. Actualizable con la inflación. Para no trabajar a pérdida sin saberlo.',
  img: 'https://cdn.magicpatterns.com/uploads/6X8n9zhxJBmG3522bSB4Mf/bono_kine_2-removebg-preview.png'
}, {
  title: 'BONO 3 — 30 Fichas de Ejercicios para Pacientes',
  desc: 'Organizadas por región y objetivo. Con instrucciones claras, dosis y señales de alarma. Imprimís, completás la dosis del paciente y entregás. Sin preparación adicional.',
  img: 'https://cdn.magicpatterns.com/uploads/4K79QzBd6NLsNbSuQN3sE1/bono_kine_3-removebg-preview.png'
}, {
  title: 'BONO 4 — Scripts de WhatsApp para Convertir Consultas en Turnos',
  desc: 'Los mensajes exactos para responder una consulta nueva, confirmar un turno, manejar una cancelación y fidelizar al paciente. Con el sistema de etiquetas de WhatsApp Business.',
  img: 'https://cdn.magicpatterns.com/uploads/vzfGmssUpMfLQxaNCsSZgC/bono_kine_4-removebg-preview.png'
}, {
  title: 'BONO 5 — Planner Semanal de Consultorio',
  desc: 'Planilla diaria, ficha de seguimiento por paciente, cierre semanal y control mensual de métricas. Para que tu semana funcione con un sistema y no con memoria.',
  img: 'https://cdn.magicpatterns.com/uploads/uH5bN7a6mnYLDFLTDGk9LS/bono_kine_5-removebg-preview.png'
}];
export function Bonos() {
  return <section className="py-16 md:py-24 px-4 bg-brand-cream relative overflow-hidden" data-id="element-15">
      <div className="max-w-7xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-brand-amber text-brand-charcoal font-bold px-6 py-2 rounded-full text-lg mb-6 shadow-md uppercase tracking-wide" data-id="element-18">
            <Gift size={20} data-id="element-19" />
            GRATIS POR EL DÍA DE HOY
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal" data-id="element-20">
            Más 5 bonos incluidos sin costo adicional
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-21">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col" data-id="element-22">
              <div className="h-72 overflow-hidden cursor-pointer group bg-brand-cream/40 flex items-center justify-center p-4" onClick={scrollToCompra} data-id="element-23">
                <img src={bono.img} alt={bono.title} className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105" data-id="element-24" />
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-25">
                <div className="flex items-center gap-2 text-brand-amber font-bold mb-3" data-id="element-26">
                  <Gift size={18} data-id="element-27" />
                  <span className="text-sm uppercase tracking-wider" data-id="element-28">
                    Regalo Incluido
                  </span>
                </div>
                <h4 className="text-xl font-bold text-brand-charcoal mb-3" data-id="element-29">
                  {bono.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed flex-grow" data-id="element-30">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}